// HKDSE 2023 Paper 1 Knowledge Graph Samples - Complete Set Part 2
// Continuing with remaining questions from the LaTeX file

export const hkdse2023Samples_complete_part2 = {
  geometry_advanced: [
    {
      id: 'hkdse2023_geometry_advanced_01',
      problem: "圖2中，$AB$ 與 $CD$ 相交於點 $E$。已知 $AC \\parallel DB$。Figure 2 description: A geometric figure showing two intersecting lines AB and CD meeting at point E. There are also line segments AC and DB which are parallel to each other. (a) 證明 $\\triangle ACE \\sim \\triangle BDE$。(b) 假定 $AB = 20$ cm、$AC = 10$ cm、$BD = 15$ cm 及 $CE = 7$ cm。$\\triangle BDE$ 是否一直角三角形？試解釋你的答案。",
      problemType: "geometry_similarity",
      difficulty: "intermediate",
      description: "Working with similar triangles and right triangles",
      graphData: {
        nodes: [
          {
            id: "intersecting_lines",
            name: "Intersecting Lines",
            type: "concepts",
            description: "AB and CD intersect at E",
            value: "AB ∩ CD = E",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "parallel_lines",
            name: "Parallel Lines",
            type: "concepts",
            description: "AC parallel to DB",
            value: "AC ∥ DB",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "similar_triangles",
            name: "Similar Triangles",
            type: "concepts",
            description: "△ACE ~ △BDE",
            value: "Triangles are similar",
            importance: 10,
            x: 200, y: 0, z: 0
          },
          {
            id: "right_triangle_check",
            name: "Right Triangle Check",
            type: "methods",
            description: "Checking if △BDE is right-angled",
            value: "Use given dimensions to check",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "intersecting_lines",
            to: "similar_triangles",
            type: "enables",
            strength: 9
          },
          {
            from: "parallel_lines",
            to: "similar_triangles",
            type: "proves",
            strength: 9
          },
          {
            from: "similar_triangles",
            to: "right_triangle_check",
            type: "enables",
            strength: 8
          }
        ]
      }
    }
  ],
  statistics: [
    {
      id: 'hkdse2023_statistics_01',
      problem: "下面的幹葉圖顯示一群工人在某星期的工作時數的分佈。Stem-and-leaf plot description: A stem-and-leaf plot with stems 2, 3, 4 and corresponding leaves: Stem 2: leaves a, 5, 5, 6, 6, 8, 8. Stem 3: leaves 3, 3, 3, 4, 5, 5, 9, 9. Stem 4: leaves 0, 1, 4, 4, 5, 6, 7, 7, 9. 該分佈的分佈域為 $27$。(a) 求該分佈的平均值及眾數。(b) 若從該群中隨機選出一名工人，求所選出的工人在該星期的工作時數超過該分佈的眾數的概率。",
      problemType: "statistics_stem_leaf",
      difficulty: "intermediate",
      description: "Analyzing stem-and-leaf diagram and calculating probabilities",
      graphData: {
        nodes: [
          {
            id: "stem_leaf_diagram",
            name: "Stem-and-Leaf Diagram",
            type: "concepts",
            description: "Data representation with stems and leaves",
            value: "2|a556688, 3|33345599, 4|014456779",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "range_given",
            name: "Range Given",
            type: "concepts",
            description: "Range of distribution is 27",
            value: "Range = 27",
            importance: 8,
            x: -200, y: 0, z: 0
          },
          {
            id: "mean_mode",
            name: "Mean and Mode",
            type: "concepts",
            description: "Calculating mean and mode",
            value: "Mean = average, Mode = most frequent",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "probability_calculation",
            name: "Probability Calculation",
            type: "concepts",
            description: "P(work hours > mode)",
            value: "P(> mode) = favorable/total",
            importance: 7,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "stem_leaf_diagram",
            to: "range_given",
            type: "constrains",
            strength: 8
          },
          {
            from: "stem_leaf_diagram",
            to: "mean_mode",
            type: "provides_data",
            strength: 9
          },
          {
            from: "mean_mode",
            to: "probability_calculation",
            type: "enables",
            strength: 7
          }
        ]
      }
    }
  ],
  locus: [
    {
      id: 'hkdse2023_locus_01',
      problem: "已知 $A$ 及 $B$ 為直角坐標平面上的兩相異點。設 $P$ 為該直角坐標平面上的一動點使得 $P$ 與 $A$ 及 $B$ 等距。將 $P$ 的軌跡記為 $\\Gamma$。(a) 描述 $\\Gamma$ 與 $AB$ 之間的幾何關係。(b) 假定 $A$ 的坐標為 $(2, -4)$ 及 $\\Gamma$ 的方程為 $3x + y - 12 = 0$。求 (i) 通過 $A$ 及 $B$ 的直線的方程，(ii) 以 $AB$ 為一直徑的圓的方程。",
      problemType: "locus_perpendicular_bisector",
      difficulty: "intermediate",
      description: "Working with locus and perpendicular bisector",
      graphData: {
        nodes: [
          {
            id: "equidistant_points",
            name: "Equidistant Points",
            type: "concepts",
            description: "P equidistant from A and B",
            value: "PA = PB",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "perpendicular_bisector",
            name: "Perpendicular Bisector",
            type: "concepts",
            description: "Γ is perpendicular bisector of AB",
            value: "Γ ⊥ AB at midpoint",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "line_equation",
            name: "Line Equation",
            type: "methods",
            description: "Finding equation of line through A and B",
            value: "y = mx + c",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "circle_equation",
            name: "Circle Equation",
            type: "concepts",
            description: "Circle with AB as diameter",
            value: "(x-h)² + (y-k)² = r²",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "equidistant_points",
            to: "perpendicular_bisector",
            type: "defines",
            strength: 10
          },
          {
            from: "perpendicular_bisector",
            to: "line_equation",
            type: "enables",
            strength: 8
          },
          {
            from: "line_equation",
            to: "circle_equation",
            type: "provides_data",
            strength: 8
          }
        ]
      }
    }
  ],
  statistics_advanced: [
    {
      id: 'hkdse2023_statistics_advanced_01',
      problem: "下表顯示某班學生擁有計算機的數目的分佈。Table description: A frequency distribution table with two rows: Row 1 (header): 擁有計算機的數目 | 1 | 2 | 3 | 4. Row 2: 學生人數 | 8 | 5 | n | 1. 該分佈的平均值為 $2$。(a) 求該分佈的中位數、四分位數間距及方差。(b) 該班現有兩名學生退學。得知該分佈的平均值維持不變。該分佈的分佈域有否因該兩名學生退學而改變？試解釋你的答案。",
      problemType: "statistics_frequency_distribution",
      difficulty: "intermediate",
      description: "Analyzing frequency distribution with missing values",
      graphData: {
        nodes: [
          {
            id: "frequency_table",
            name: "Frequency Table",
            type: "concepts",
            description: "Distribution of calculators per student",
            value: "1: 8, 2: 5, 3: n, 4: 1 students",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "mean_given",
            name: "Mean Given",
            type: "concepts",
            description: "Mean of distribution is 2",
            value: "Mean = 2",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "missing_value",
            name: "Missing Value",
            type: "variables",
            description: "n to be determined",
            value: "n",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "statistical_measures",
            name: "Statistical Measures",
            type: "concepts",
            description: "Median, IQR, variance",
            value: "Calculate median, IQR, variance",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "frequency_table",
            to: "mean_given",
            type: "constrains",
            strength: 9
          },
          {
            from: "mean_given",
            to: "missing_value",
            type: "determines",
            strength: 9
          },
          {
            from: "missing_value",
            to: "statistical_measures",
            type: "enables",
            strength: 8
          }
        ]
      }
    }
  ],
  functions: [
    {
      id: 'hkdse2023_functions_01',
      problem: "已知 $f(x)$ 的一部分為常數，而另一部分則隨 $x^2$ 正變。假定 $f(10) = 62$ 及 $f(15) = 122$。(a) 求 $f(5)$。(b) 假定 $U(0, u)$ 及 $V(5, v)$ 均為 $y = f(x)$ 的圖像上的點。通過 $V$ 的水平線與 $y$ 軸相交於點 $W$。將通過 $U$、$V$ 及 $W$ 的圓記為 $C$。以 $\\pi$ 表 $C$ 的圓周。",
      problemType: "functions_direct_variation",
      difficulty: "intermediate",
      description: "Working with functions involving direct variation",
      graphData: {
        nodes: [
          {
            id: "function_structure",
            name: "Function Structure",
            type: "concepts",
            description: "f(x) = constant + k(x²)",
            value: "f(x) = c + kx²",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "direct_variation",
            name: "Direct Variation",
            type: "concepts",
            description: "Part varies directly as x²",
            value: "kx² where k is constant",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "system_equations",
            name: "System of Equations",
            type: "methods",
            description: "Using given values to find constants",
            value: "f(10) = 62, f(15) = 122",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "circle_circumference",
            name: "Circle Circumference",
            type: "concepts",
            description: "Circumference of circle through U, V, W",
            value: "C = 2πr",
            importance: 7,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "function_structure",
            to: "direct_variation",
            type: "includes",
            strength: 9
          },
          {
            from: "system_equations",
            to: "function_structure",
            type: "determines",
            strength: 9
          },
          {
            from: "function_structure",
            to: "circle_circumference",
            type: "enables",
            strength: 7
          }
        ]
      }
    }
  ],
  polynomials: [
    {
      id: 'hkdse2023_polynomials_01',
      problem: "定義 $g(x) = x^3 + 5x^2 - 12x - 1$。設 $h(x) = 3x^4 + ax^3 - 16x^2 + bx + c$，其中 $a$、$b$ 及 $c$ 均為常數。當 $h(x)$ 除以 $g(x)$ 時，商式與餘式相等。(a) 求當 $h(x)$ 除以 $g(x)$ 時的商式。(b) 方程 $h(x) = 0$ 有多少個有理根？試解釋你的答案。",
      problemType: "polynomials_division",
      difficulty: "advanced",
      description: "Working with polynomial division and rational roots",
      graphData: {
        nodes: [
          {
            id: "cubic_polynomial",
            name: "Cubic Polynomial",
            type: "concepts",
            description: "g(x) = x³ + 5x² - 12x - 1",
            value: "g(x) = x³ + 5x² - 12x - 1",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "quartic_polynomial",
            name: "Quartic Polynomial",
            type: "concepts",
            description: "h(x) = 3x⁴ + ax³ - 16x² + bx + c",
            value: "h(x) = 3x⁴ + ax³ - 16x² + bx + c",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "division_condition",
            name: "Division Condition",
            type: "concepts",
            description: "Quotient equals remainder",
            value: "h(x) = g(x) × q(x) + q(x)",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "rational_roots",
            name: "Rational Roots",
            type: "concepts",
            description: "Counting rational roots of h(x) = 0",
            value: "Use rational root theorem",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "cubic_polynomial",
            to: "division_condition",
            type: "divides",
            strength: 9
          },
          {
            from: "quartic_polynomial",
            to: "division_condition",
            type: "divided_by",
            strength: 9
          },
          {
            from: "division_condition",
            to: "rational_roots",
            type: "constrains",
            strength: 8
          }
        ]
      }
    }
  ],
  mensuration: [
    {
      id: 'hkdse2023_mensuration_01',
      problem: "某實心金屬直立圓錐體的底半徑及曲面面積分別為 $14$ cm 及 $700\\pi$ cm$^2$。(a) 求該圓錐體的高。(b) 將該圓錐體以一平行於其底的平面分成一直立圓錐體 $X$ 及一平截頭體 $Y$。$Y$ 的曲面面積為 $X$ 的曲面面積之 $15$ 倍。(i) 以 $\\pi$ 表 $Y$ 的體積。(ii) 若把 $Y$ 熔化，並重鑄成 $2$ 個完全相同的實心球體，求每個球體的直徑。",
      problemType: "mensuration_cone_frustum",
      difficulty: "advanced",
      description: "Working with cone, frustum, and sphere volumes",
      graphData: {
        nodes: [
          {
            id: "cone_dimensions",
            name: "Cone Dimensions",
            type: "concepts",
            description: "Radius and curved surface area",
            value: "Radius = 14cm, CSA = 700π cm²",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "height_calculation",
            name: "Height Calculation",
            type: "methods",
            description: "Finding height of cone",
            value: "h = CSA/(πr)",
            importance: 8,
            x: -200, y: 0, z: 0
          },
          {
            id: "frustum_volume",
            name: "Frustum Volume",
            type: "concepts",
            description: "Volume of frustum Y",
            value: "V = (1/3)πh(r₁² + r₁r₂ + r₂²)",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "sphere_diameter",
            name: "Sphere Diameter",
            type: "concepts",
            description: "Diameter of each sphere",
            value: "V = (4/3)πr³",
            importance: 7,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "cone_dimensions",
            to: "height_calculation",
            type: "enables",
            strength: 8
          },
          {
            from: "height_calculation",
            to: "frustum_volume",
            type: "provides_data",
            strength: 8
          },
          {
            from: "frustum_volume",
            to: "sphere_diameter",
            type: "enables",
            strength: 7
          }
        ]
      }
    }
  ],
  probability: [
    {
      id: 'hkdse2023_probability_01',
      problem: "某盒子內有 $5$ 個紅球及 $4$ 個黑球。從該盒子中隨機同時抽出 $2$ 個球。(a) 求所抽出的 $2$ 個球均為紅色的概率。(b) 某袋子內有 $8$ 個紅球。把從該盒子中所抽出的 $2$ 個球放入該袋子內，然後從該袋子中隨機同時抽出 $3$ 個球。求所抽出的 $3$ 個球為相同顏色的概率。",
      problemType: "probability_combinations",
      difficulty: "intermediate",
      description: "Calculating probabilities using combinations",
      graphData: {
        nodes: [
          {
            id: "ball_distribution",
            name: "Ball Distribution",
            type: "concepts",
            description: "Number of balls of each color",
            value: "Red: 5, Black: 4",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "red_balls_probability",
            name: "Red Balls Probability",
            type: "concepts",
            description: "P(2 red balls)",
            value: "P(2 red) = C(5,2)/C(9,2)",
            importance: 8,
            x: -200, y: 0, z: 0
          },
          {
            id: "bag_transfer",
            name: "Bag Transfer",
            type: "concepts",
            description: "Transferring balls to new bag",
            value: "Add 2 balls to bag with 8 red",
            importance: 7,
            x: 200, y: 0, z: 0
          },
          {
            id: "same_color_probability",
            name: "Same Color Probability",
            type: "concepts",
            description: "P(3 balls same color)",
            value: "P(same color) = favorable/total",
            importance: 7,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "ball_distribution",
            to: "red_balls_probability",
            type: "provides_data",
            strength: 8
          },
          {
            from: "red_balls_probability",
            to: "bag_transfer",
            type: "affects",
            strength: 7
          },
          {
            from: "bag_transfer",
            to: "same_color_probability",
            type: "enables",
            strength: 7
          }
        ]
      }
    }
  ]
}; 